import { styled } from '@mui/system';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const StyledBreadcrumbs = styled(Breadcrumbs, {
  shouldForwardProp: prop => prop !== 'breadcrumbColor' && prop !== 'lastBreadcrumbColor'
})(({ breadcrumbColor, lastBreadcrumbColor }) => ({
  color: breadcrumbColor,
  '&.MuiTypography-root': {
    marginLeft: 20
  },
  '& .MuiTypography-root': {
    flexWrap: 'nowrap'
  },
  '& .MuiBreadcrumbs-ol': {
    flexWrap: 'nowrap'
  },
  '& .MuiBreadcrumbs-li': {
    textAlign: 'left',
    color: `${breadcrumbColor} !important`,
    '& a': {
      display: 'flex'
    },
    '& p': {
      color: lastBreadcrumbColor
    }
  },
  '& .MuiBreadcrumbs-separator': {
    color: `${breadcrumbColor} !important`
  }
}));

export const MobileBreadcrumbContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  '& p': {
    maxWidth: 260,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    textOverflow: 'ellipsis'
  }
}));

export const StyledLink = styled(Link, {
  shouldForwardProp: prop => prop !== 'breadcrumbColor'
})(({ breadcrumbColor }) => ({
  verticalAlign: 'middle',
  flexWrap: 'nowrap',
  color: `${breadcrumbColor} !important`
}));

export const StyledExpandIcon = styled(ExpandMoreIcon, {
  shouldForwardProp: prop => prop !== 'lastBreadcrumbColor'
})(({ lastBreadcrumbColor }) => ({
  color: lastBreadcrumbColor
}));

export const StyledTypography = styled(Typography)(() => ({
  flexWrap: 'nowrap'
}));
